import Transaction from './Transaction';
import TransactionType from './TransactionType';
import FLSApiClient from '../../common/FLSApiClient';

interface FetchManyParams {
  nbResult?: number;
}

const fetchMany = (sessionId: string, params: FetchManyParams = {}): Promise<Transaction[]> => {
  const formattedParams: { [key: string]: any } = {
    'request.sessionId': sessionId,
  };
  for (const [key, value] of Object.entries(params)) {
    formattedParams[`request.${key}`] = value;
  }

  return FLSApiClient.get(`/api/Card/Transactions`, {
    params: formattedParams,
  }).then((response) => {
    return response.data.CardTransactions as Transaction[];
  });
};

const fetchTypes = (): Promise<TransactionType[]> => {
  return FLSApiClient.get(`/api/TransactionType/Get`).then((response) => {
    return response.data.TransactionTypes as TransactionType[];
  });
};

export default { fetchMany, fetchTypes };
